module.exports = __webpack_public_path__ + "img/copy-icon.7516521c.svg";